<script lang="ts">
    import { cart } from "../../stores/cart";
    import { cartPopupOpen } from "../../stores/cart-popup-open.js";
    import Menu from "$lib/menu/Menu.svelte";
    import { menu, adminMenu } from "$lib/menu/menu.lib";
    import MenuHider from "$lib/menu/MenuHider.svelte";
    import Cart from "./Cart.svelte";
    import { trackNavigationClickTypes, trackNavigationClick } from "../../utils/track.utils";

    let isSubmenuOpen = false;
    export let menuType: "user" | "admin" = "user";

    const menuTypeMap = {
        admin: adminMenu,
        user: menu,
    };
</script>

<MenuHider --header-height="200px" active={!$cartPopupOpen && !isSubmenuOpen}>
    <header>
        <!-- Main menu container #########-->
        <div class="flex h-[115px] mx-auto max-w-xl md:max-w-3xl lg:max-w-4xl xl:max-w-6xl justify-between gap-4">
            <!-- Search ####### -->
            <div class="w-1/3 my-auto ml-4 mr-8">
                <form
                    class=" relative mx-auto w-full text-gray-600"
                    action="/sok-mattor/"
                    method="GET"
                    data-sveltekit-reload
                >
                    <input
                        class=" bg-white h-10 px-5 pr-6 rounded-lg text-md focus:outline-none w-full"
                        type="search"
                        name="s"
                        placeholder="Sök i vårt sortiment"
                    />
                    <button type="submit" aria-label="Genomför sökning" class="absolute right-0 -top-2 mt-5 mr-4">
                        <svg
                            class="text-gray-600 h-4 w-4 fill-current"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            version="1.1"
                            id="Capa_1"
                            x="0px"
                            y="0px"
                            viewBox="0 0 56.966 56.966"
                            style="enable-background:new 0 0 56.966 56.966;"
                            xml:space="preserve"
                        >
                            <path
                                d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z"
                            />
                        </svg>
                    </button>
                </form>
            </div>

            <!-- 2  ######### -->
            <div class="my-auto shrink-0 flex">
                <a
                    class="mx-auto"
                    href="/"
                    data-sveltekit-preload-data="hover"
                    tabindex="-1"
                    on:click={() => trackNavigationClick(trackNavigationClickTypes.LOGO_CLICK, "Logo")}
                >
                    <img
                        width="250"
                        height="62"
                        src="/images/logo/nylanders-logo-desktop-white.png"
                        srcset="/images/logo/nylanders-logo-desktop-white.png 1x, /images/logo/nylanders-logo-desktop-white-2x.png 2x"
                        alt="Nylanders logotyp"
                        style="width: 250px; height: 62px;"
                    />
                </a>
            </div>

            <!-- CART ######### -->
            <div class="w-1/3 xs:pr-10 sm:pr-20 flex justify-center">
                <Cart {cart} />
            </div>
        </div>
        <Menu menu={menuTypeMap[menuType || "user"]} onSubmenuToggle={(isOpen) => (isSubmenuOpen = isOpen)} />
    </header>
</MenuHider>
<div class="pt-[170px]" />

<style>
    header {
        color: white;
        width: 100%;
        height: 170px;
        background: rgb(17, 17, 17);
        background: linear-gradient(270deg, rgba(17, 17, 17, 1) 0%, rgba(43, 43, 43, 1) 50%, rgba(17, 17, 17, 1) 100%);
    }
</style>
